export default __webpack_public_path__ + "static/media/ui_store_experience_bundle_01.6c402f97.png";